import React from 'react';

import './preferenceCenter.scss';

export class PreferenceCenter extends React.Component {

    constructor (props) {
        super(props);
    }

    render () {
        return (
            <div className="preferenceCenter">
                <h1>Preference Center</h1>
            </div>
        );
    }
}

